// de strings for messages/train.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const train: Dict = {
  "train.seo.title": "Eigene KI-Stimmen trainieren | Jammable",
  "train.seo.description":
    "Trainiere deine eigenen KI-Stimmen auf Jammable. Lade Audiodateien hoch, trainiere ein Stimmmodell und teile es mit der Community oder halte es privat.",
  "train.h1": "Stimme trainieren",
  "train.sub":
    "Ein paar Minuten sauberer Gesang oder Sprache rein, eine Stimme für deine Cover raus.",
  "train.voicesTrained": "{count} Stimmen trainiert",

  "train.faq.title": "Häufige Fragen",
  "train.faq.dataset.q": "Was ist ein Datensatz?",
  "train.faq.dataset.a1":
    "Eine Sammlung von Audiodateien mit Gesang oder Sprache.",
  "train.faq.dataset.a2":
    "Mindestens {min} Minuten Gesang oder Sprache, am besten 10+.",
  "train.faq.dataset.a3": "Im Format MP3, WAV oder M4A.",
  "train.faq.private.q": "Ist meine eigene Stimme privat?",
  "train.faq.private.a":
    "Ja! Wenn du sie privat hältst, kannst nur du dein eigenes Stimmmodell sehen, aufrufen und nutzen!",
  "train.faq.time.q": "Wie lange dauert das Training meiner Stimme?",
  "train.faq.time.a":
    "Das hängt davon ab, wie viel Audio du hinzufügst: meist {short} für 10 Minuten Audio, {long} für eine Stunde. Du kannst die Seite schließen; wir schicken dir eine E-Mail, wenn sie fertig ist.",

  "train.eta.minutes": "etwa {m} Minuten",
  "train.eta.hour": "etwa {h} Stunde",
  "train.eta.hours": "etwa {h} Stunden",
  "train.eta.hourMinutes": "etwa {h} Stunde {m} Minuten",
  "train.eta.hoursMinutes": "etwa {h} Stunden {m} Minuten",
  "train.minutes": "{n} Minuten",

  "train.samples": "Samples",
  "train.filesOne": "1 Datei · {time}",
  "train.filesMany": "{n} Dateien · {time}",
  "train.passesLeft": "Verbleibende Trainingspässe",
  "train.unlimited": "Unbegrenzt",
  "train.nameIt": "Name",
  "train.creatorShort": "Training ist in Creator enthalten.",

  "train.upload.invalidType": "Ungültiger Dateityp.",
  "train.upload.skippedOne":
    "{names} übersprungen: schon hinzugefügt. Dasselbe Audio zweimal hilft deiner Stimme nicht, deshalb zählt es nur einmal.",
  "train.upload.skippedMany":
    "{names} übersprungen: schon hinzugefügt. Dasselbe Audio zweimal hilft deiner Stimme nicht, deshalb zählt es nur einmal.",
  "train.upload.nFiles": "{n} Dateien",
  "train.upload.someInvalid": "Eine oder mehrere Dateien sind ungültig.",
  "train.upload.failed": "Upload fehlgeschlagen",
  "train.upload.needsPlan": "Zum Hochladen brauchst du einen Plan",
  "train.upload.tooManyLabel":
    "Gerade zu viele Uploads, versuch es gleich nochmal",
  "train.upload.tooManyToast":
    "Gerade zu viele Uploads. Versuch es in ein paar Minuten nochmal.",
  "train.upload.analysing":
    "Wir suchen noch die Stille in deinen Dateien. Einen Moment.",
  "train.upload.blocked":
    "Einige Dateien sind blockiert. Bitte entferne sie, um fortzufahren.",
  "train.upload.errored":
    "Einige Dateien haben Fehler. Bitte entferne sie, um fortzufahren.",
  "train.upload.processing":
    "Einige Dateien werden noch verarbeitet. Bitte warte, bis sie fertig sind.",
  "train.upload.tooShort":
    "Du brauchst {min} Gesang oder Sprache, ohne die Stille. Du hast {have}.",
  "train.upload.tooLong":
    "Bis zu {max} Audio. Du hast {have}: Entferne eine Datei oder schneide etwas heraus.",
  "train.upload.title": "Füge deine Stimme hinzu",
  "train.upload.ofMin": "von {min}",
  "train.upload.overLimit": "{over} über dem Limit von {n} Minuten",
  "train.upload.ready": "Bereit ✓",
  "train.upload.addMore": "Noch {left} hinzufügen",
  "train.upload.short":
    "Stimmen klingen meist besser mit {n}+ Minuten. Du kannst jetzt trainieren oder noch {left} hinzufügen, wenn du mehr hast.",
  "train.upload.uploadFiles": "Dateien hochladen",
  "train.upload.record": "Aufnehmen",
  "train.upload.addIt": "Hinzufügen",
  "train.upload.recordHint":
    "Sing oder sprich. Nimm so viel auf, wie du willst.",
  "train.upload.blockedFrom": "Blockiert – Inhalt von {label}",
  "train.upload.gettingReady": "Wird vorbereitet...",
  "train.upload.ofVoice": "{time} Stimme",
  "train.upload.removed": "{time} entfernt",
  "train.upload.uploading": "wird hochgeladen...",
  "train.upload.done": "Fertig",
  "train.upload.trim": "Kürzen",
  "train.upload.retry": "Erneut versuchen",
  "train.upload.remove": "{name} entfernen",
  "train.upload.silenceNote":
    "Stille wird automatisch entfernt. Lila ist das, woraus deine Stimme lernt.",
  "train.upload.tip1.title": "Nur eine Stimme",
  "train.upload.tip1.sub": "Keine Backgroundsänger, kein Publikum",
  "train.upload.tip2.title": "Ruhiger Raum",
  "train.upload.tip2.sub": "Kein Hall, keine Hintergrundgeräusche",
  "train.upload.tip3.title": "Mehr ist besser",
  "train.upload.tip3.sub": "Verschiedene Töne und Wörter",
  "train.upload.nextHint": "Als Nächstes: Name, Bild und wer sie nutzen darf.",
  "train.upload.cardTitle": "Deine Samples",
  "train.upload.footnote":
    "Mindestens {min} Gesang oder Sprache ({rec}+ klingt besser), bis zu {max}. Stille und doppelte Dateien zählen nicht; Stille wird automatisch herausgeschnitten.",
  "train.upload.footnoteNoRec":
    "Mindestens {min} Gesang oder Sprache, bis zu {max}. Stille und doppelte Dateien zählen nicht; Stille wird automatisch herausgeschnitten.",
  "train.upload.creatorNote":
    "Training ist in Creator enthalten. Lade zuerst deinen Gesang hoch und entscheide am Ende; du siehst den Preis, bevor du zahlst.",
  "train.upload.continue": "Weiter",

  "train.sample.play": "{label} abspielen",
  "train.sample.pause": "{label} pausieren",
  "train.clip.keptOf": "behalten von {total}",
  "train.clip.silenceCut": "{time} Stille herausgeschnitten",
  "train.clip.cutByYou": "{time} von dir herausgeschnitten",
  "train.clip.cut": "geschnitten",
  "train.clip.play": "Abspielen",
  "train.clip.stop": "Stopp",
  "train.clip.keepIt": "Behalten",
  "train.clip.cutIt": "Schneiden",
  "train.clip.cancel": "Abbrechen",
  "train.clip.hint":
    "Zieh über den Teil, den du nicht willst, und schneide ihn heraus. Tippe zum Anhören.",
  "train.clip.undo": "Meine Schnitte rückgängig machen",

  "train.info.samplesAdded": "Samples hinzugefügt",
  "train.info.edit": "Bearbeiten",
  "train.info.namePlaceholder": "Name der Stimme, z. B. Meine Stimme",
  "train.info.descPlaceholder":
    "Beschreibung – erzähl der Community mehr darüber, wie die Stimme trainiert wurde...",
  "train.info.whoCanUse": "Wer sie nutzen darf",
  "train.info.private": "Privat, nur ich",
  "train.info.public": "Öffentlich in der Bibliothek",
  "train.info.cleanUp": "Samples bereinigen",
  "train.info.removeInstrumentals": "Instrumentals entfernen",
  "train.info.removeInstrumentalsSub":
    "Entfernt alles, was kein Gesang ist, aus dem Datensatz.",
  "train.info.removeReverb": "Hall entfernen",
  "train.info.removeReverbSub": "Entfernt Hall aus allen Audios im Datensatz.",
  "train.info.cardTitle": "Bereit zum Training",
  "train.info.usuallyReadyIn": "Meist fertig in",
  "train.info.upTo2h": "Bis zu 2 Stunden",
  "train.info.closePage":
    "Das Training läuft bei uns, du kannst die Seite also schließen.",
  "train.info.starting": "Wird gestartet...",
  "train.info.start": "Training starten",
  "train.info.orGetPass": "Oder hol dir einen Trainingspass",
  "train.info.getMorePasses": "Mehr Trainingspässe holen",
  "train.info.usesOnePass": "Verbraucht 1 Trainingspass",
  "train.info.started": "Training gestartet",
  "train.info.onCreator": "Du hast Creator. Dein Training startet...",
  "train.info.legal":
    "Mit dem Fortfahren gibst du Jammable das Recht, die von dir hochgeladenen Inhalte zu nutzen, und BESTÄTIGST, DASS DIESE INHALTE DIR GEHÖREN UND KEIN URHEBERRECHTLICH GESCHÜTZTES MATERIAL DRITTER ENTHALTEN.",
  "train.info.agreeTerms": "Bitte stimme unseren Nutzungsbedingungen zu!",
  "train.info.chooseName": "Bitte wähle einen Namen für die Stimme!",
  "train.info.uploadImage": "Bitte lade ein Bild hoch!",
  "train.info.invalidName": "Ungültiger Modellname. Keine Sonderzeichen",
  "train.info.signIn": "Du musst angemeldet sein",
  "train.info.errorStarting": "Fehler beim Starten des Trainings",
  "train.info.errorSignedUrl": "Fehler beim Abrufen der signierten URL",

  "train.demo.title": "Hör dir eine trainierte Stimme an",
  "train.demo.by": "Von einem Jammable Power-Nutzer",
  "train.demo.data.label": "Trainingsdaten",
  "train.demo.data.note": "Ein paar Minuten einer Stimme",
  "train.demo.input.label": "Input-Song",
  "train.demo.input.note": "Der Song, den sie singen wird",
  "train.demo.output.label": "Endergebnis",
  "train.demo.output.note": "Gesungen mit der trainierten Stimme",
  "train.demo.play": "{label} abspielen",
  "train.demo.pause": "{label} pausieren",

  "train.retry.trainAgain": "Neu trainieren",
  "train.retry.tryAgain": "Erneut versuchen",
  "train.retry.orNewSamples": "Oder mit neuen Samples trainieren",
  "train.retry.retrying":
    "Wird neu trainiert. Wir schicken dir eine E-Mail, wenn sie fertig ist.",
  "train.retry.couldntStart":
    "Training konnte nicht gestartet werden. Versuch es erneut.",
  "train.retry.confirmUnlimited":
    "Wir trainieren sie mit denselben Samples neu. In deinem Plan enthalten.",
  "train.retry.confirmOutCreator":
    "Ein neuer Versuch verbraucht einen Trainingspass, und du hast keinen mehr. Training ist in Creator enthalten.",
  "train.retry.confirmOut":
    "Ein neuer Versuch verbraucht einen Trainingspass, und du hast keinen mehr.",
  "train.retry.confirmPass":
    "Wir trainieren sie mit denselben Samples neu. Verbraucht 1 Trainingspass (du hast {passes}); wenn es wieder fehlschlägt, bekommst du ihn zurück.",
  "train.retry.cancel": "Abbrechen",
  "train.retry.seeCreator": "Creator ansehen",
  "train.retry.getPass": "Trainingspass holen",
  "train.retry.orGetPass": "Oder hol dir einen Trainingspass",
  "train.retry.starting": "Wird gestartet...",
  "train.retry.usePass": "Pass nutzen und erneut versuchen",
  "train.retry.refuse.cleanVocals":
    "Ein neuer Versuch würde genauso scheitern. Trainiere sie mit sauberem Gesang neu: keine Musik, keine langen Pausen.",
  "train.retry.refuse.formats":
    "Ein neuer Versuch würde genauso scheitern. Trainiere sie mit MP3-, WAV- oder M4A-Dateien mit klarem Gesang oder klarer Sprache neu.",
  "train.retry.refuse.newSamples":
    "Ein neuer Versuch würde genauso scheitern. Trainiere sie mit neuen Samples neu.",
  "train.retry.refuse.saveAs":
    "Ein neuer Versuch würde genauso scheitern. Speichere sie als MP3 oder WAV und trainiere sie neu.",
  "train.retry.refuse.filesMissing": "Trainiere sie mit neuen Samples neu.",
  "train.retry.refuse.retryCap":
    "Diese Stimme wurde schon {n}-mal versucht. Trainiere sie neu, am besten mit anderen Samples.",

  "train.final.confirm": "Bestätigen",
  "train.final.back": "Zurück",
  "train.final.next": "Weiter",
};

export default train;
